import axios from "axios";

// Prefer the current window origin at runtime so the same bundle works on
// preview, prod, and any custom domain (e.g. baim.ma). Falls back to the
// build-time REACT_APP_BACKEND_URL for non-browser contexts (tests, SSR).
const BACKEND_URL = (typeof window !== "undefined" && window.location?.origin)
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Iter-45: incremental Google scopes — when a foreground call needs Drive/Gmail/Directory and
// the user hasn't granted the corresponding bundle yet, the backend responds with
// 403 { detail: { code: "missing_scope", bundle: "drive"|"gmail"|"directory" } }.
// We auto-redirect (silent) to /api/auth/google/elevate?scope=<bundle>&next=<current path>
// so Google can prompt for the new scope, then the user lands back on the same page.
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    try {
      const data = err?.response?.data;
      const detail = data && (typeof data === "object" ? data.detail : null);
      if (
        err?.response?.status === 403 &&
        detail &&
        typeof detail === "object" &&
        !Array.isArray(detail) &&
        detail.code === "missing_scope" &&
        detail.bundle
      ) {
        if (typeof window !== "undefined" && window.__baim_elevating !== true) {
          window.__baim_elevating = true;
          const next = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.href = `${API}/auth/google/elevate?scope=${encodeURIComponent(detail.bundle)}&next=${next}`;
        }
      }
      // Iter-162: FastAPI/Pydantic 2 validation errors return `detail` as an array
      // of {type, loc, msg, input, url} dicts. Sonner / React then crash with
      // "Objects are not valid as a React child" when callsites render the value
      // directly via `toast.error(e?.response?.data?.detail || "Save failed")`.
      // We coerce the array to a single human-readable string at the interceptor
      // level so every callsite stays unchanged.
      if (data && Array.isArray(data.detail)) {
        const msgs = data.detail
          .map((d) => {
            if (!d) return "";
            if (typeof d === "string") return d;
            const loc = Array.isArray(d.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
            const m = d.msg || d.message || "Validation error";
            return loc ? `${loc}: ${m}` : m;
          })
          .filter(Boolean);
        data.detail = msgs.length ? msgs.join(" · ") : "Validation error";
      } else if (data && data.detail && typeof data.detail === "object" && !data.detail.code) {
        // Generic dict (non-missing_scope) — pretty-print so it doesn't render as [object Object].
        try { data.detail = JSON.stringify(data.detail); } catch (_e) { data.detail = "Server error"; }
      }
    } catch (_e) { /* swallow */ }
    return Promise.reject(err);
  }
);

export const MISSION_COLORS = [
  "#2563EB", "#CA8A04", "#C2410C", "#4F46E5", "#059669", "#DB2777", "#0891B2", "#7C3AED",
];

export const ACTIVITY_COLORS = {
  SICK: "#991B1B",
  ABSENCE: "#52525B",
  ONBOARDING: "#15803D",
  TRAINING: "#9333EA",
  DAILY: "#1E3A5F",
  CONGE: "#0EA5E9",
};

export const ACTIVITY_LABELS = {
  MISSION: "Mission",
  SICK: "Sick leave",
  ABSENCE: "Unjustified absence",
  ONBOARDING: "Onboarding",
  TRAINING: "Training",
  DAILY: "Daily",
  CONGE: "Paid leave",
};
